"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOasOperations = void 0;
const lodash_1 = require("lodash");
const DEFAULT_METHODS = ['get', 'post', 'put', 'delete', 'options', 'head', 'patch', 'trace'];
function transformOasOperations(document, transformer, methods = DEFAULT_METHODS) {
    const paths = lodash_1.keys(lodash_1.get(document, 'paths'));
    return lodash_1.flatten(lodash_1.map(paths, path => {
        let operations = lodash_1.keys(lodash_1.get(document, ['paths', path]));
        if (methods !== null) {
            operations = operations.filter(pathKey => methods.includes(pathKey));
        }
        return operations.map(method => transformer({
            document,
            path,
            method,
        }));
    }));
}
exports.transformOasOperations = transformOasOperations;
//# sourceMappingURL=operation.js.map